import React from 'react';
import {
  Button,
  FormControl,
  Chip,
  FormControlLabel,
  FormLabel,
  FormGroup,
  Checkbox,
  TextField,
} from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setData } from '../../../redux';
import { sortByDate } from '../../../../helperFunctions';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import TransferToCellMaterials from '../../TransferToCellMaterials';
import DeinstalledDevicesDialog from './DeinstalledDevicesDialog';
import DeinstalledDevicesList from './DeinstalledDevicesList';
import {
  addDocumentStyle,
  removeDocumentStyle,
  troubleProtocolActionsWithNote,
} from '../constants';
import MaterialsSell from '../../MaterialsSell';

export default () => {
  const data = useSelector(state => state.tasks.data);
  const startedTaskId = useSelector(state => state.tasks.taskStarted.taskId);
  const task = data.tasks.find(x => x.id === startedTaskId);

  if (!task) return null;
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const troubleProtocol = task ? task.troubleProtocol : null;
  const { actionsTaken, additionalActions, circumstances, failedActions } = troubleProtocol;
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  const fontSize = width <= 500 ? '4vw' : '20px';

  const circumstancesTexts = [
    { name: 'circumstance01', label: 'Няма проблем с услугите, предоставяни на абоната' },
    { name: 'circumstance02', label: 'Проблем с оборудване на клиент' },
    { name: 'circumstance03', label: 'Проблем в мрежа извън помещенията на абоната' },
    { name: 'circumstance04', label: 'Проблем с оборудване на А1 България ЕАД' },
    { name: 'circumstance05', label: 'Проблем в мрежата в помещенията на абоната' },
    { name: 'circumstance06', label: 'Друго (подробности в „Забележка")' },
  ];

  const additionalActionsTexts = [
    {
      name: 'additionalAction1',
      label: 'Такса инженерно посещение (10.22 EUR / 19.99 лв.)',
    },
    {
      name: 'additionalAction2',
      label: 'Такса повредено оборудване за цифрова телевизия (51.12 EUR / 99.99 лв.)',
    },
    {
      name: 'additionalAction3',
      label: 'Такса повредено оборудване за фиксиран интернет (25.56 EUR / 49.99 лв.)',
    },
  ];

  const actionsTakenTexts = [
    {
      name: 'actionTaken1',
      label: 'Констатираните проблеми са отстранени и услугите работят коректно.',
    },
    {
      name: 'actionTaken2',
      label:
        'Дадени са инструкции за начина на работа с оборудването предоставено от „А1 България“ ЕАД ',
    },
    {
      name: 'actionTaken3',
      label:
        'Абонатът е уведомен за проблемите в изградената от него вътрешна мрежа и реда за отстраняване.',
    },
    {
      name: 'actionTaken4',
      label:
        'Абонатът е уведомен, че проблемите са свързани с предоставеното му оборудване и че те са настъпили по причина, за която той отговаря, поради което трябва да заплати обезщетение в размер на стойността на оборудването, съгласно ценоразписа на „А1 България“ ЕАД.',
    },
    { name: 'actionTaken5', label: 'Друго:' },
  ];

  const failedActionTexts = [
    { name: 'failedAction1', label: 'Абонатът не е предоставил достъп' },
    { name: 'failedAction2', label: 'Абонатът е отказал без конкретна причина' },
    { name: 'failedAction3', label: 'Други' },
  ];

  const handleActionTakenChange = event => {
    const updatedActionsTaken = [...troubleProtocol.actionsTaken];
    const actionTaken = actionsTaken.find(c => c.name === event.target.name);

    updatedActionsTaken.splice(actionsTaken.indexOf(actionTaken), 1, {
      ...actionTaken,
      checked: event.target.checked,
    });

    const updatedTroubleProtocol = { ...troubleProtocol, actionsTaken: updatedActionsTaken };

    const updatedTask = {
      ...task,
      troubleProtocol: updatedTroubleProtocol,
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const handleActionTakenNoteChange = event => {
    const updatedTroubleProtocol = { ...troubleProtocol };
    updatedTroubleProtocol.actionTakenNote = event.target.value;

    const updatedTask = {
      ...task,
      troubleProtocol: updatedTroubleProtocol,
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const handleAdditionalActionsChange = event => {
    const updatedAdditionalActions = [...troubleProtocol.additionalActions];
    const additionaAction = additionalActions.find(c => c.name === event.target.name);
    updatedAdditionalActions.splice(additionalActions.indexOf(additionaAction), 1, {
      ...additionaAction,
      checked: event.target.checked,
    });

    const updatedTroubleProtocol = {
      ...troubleProtocol,
      additionalActions: updatedAdditionalActions,
    };

    const updatedTask = {
      ...task,
      troubleProtocol: updatedTroubleProtocol,
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const handleCircumstancesChange = event => {
    const updatedCircumstances = [...circumstances];
    const circumstance = circumstances.find(c => c.name === event.target.name);
    updatedCircumstances.splice(circumstances.indexOf(circumstance), 1, {
      ...circumstance,
      checked: event.target.checked,
    });

    const updatedTroubleProtocol = {
      ...troubleProtocol,
      circumstances: updatedCircumstances,
    };

    const updatedTask = {
      ...task,
      troubleProtocol: updatedTroubleProtocol,
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const handleCircumstanceNote = event => {
    const updatedTroubleProtocol = { ...troubleProtocol };
    updatedTroubleProtocol.circumstanceNote = event.target.value;

    const updatedTask = {
      ...task,
      troubleProtocol: updatedTroubleProtocol,
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const handleFailedActionsChange = event => {
    const updatedFailedActions = [...failedActions];
    const failedAction = failedActions.find(f => f.name === event.target.name);
    updatedFailedActions.splice(failedActions.indexOf(failedAction), 1, {
      ...failedAction,
      checked: event.target.checked,
    });

    const updatedTroubleProtocol = {
      ...troubleProtocol,
      failedActions: updatedFailedActions,
    };

    const updatedTask = {
      ...task,
      troubleProtocol: updatedTroubleProtocol,
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const handleFailedActionNoteChange = event => {
    const updatedTroubleProtocol = { ...troubleProtocol };
    updatedTroubleProtocol.failedActionNote = event.target.value;

    const updatedTask = {
      ...task,
      troubleProtocol: updatedTroubleProtocol,
    };

    const updatedTasks = [...data.tasks];
    updatedTasks.splice(taskIndex, 1, updatedTask);

    dispatch(
      setData({
        ...data,
        tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  return (
    <>
      <Button
        variant="contained"
        style={troubleProtocol && troubleProtocol.open ? removeDocumentStyle : addDocumentStyle}
        onClick={() => {
          const updatedTroubleProtocol = { ...troubleProtocol };
          updatedTroubleProtocol.open = !updatedTroubleProtocol.open;

          const updatedTask = {
            ...task,
            troubleProtocol: updatedTroubleProtocol,
          };

          const updatedTasks = [...data.tasks];
          updatedTasks.splice(taskIndex, 1, updatedTask);

          dispatch(
            setData({
              ...data,
              tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
            })
          );
        }}
      >
        {troubleProtocol && troubleProtocol.open
          ? 'Премахни Протокол за повреда'
          : 'Добави Протокол за повреда'}
      </Button>
      {troubleProtocol && troubleProtocol.open ? (
        <>
          <div style={{ margin: '3px' }}>
            <TransferToCellMaterials />
          </div>
          <Chip
            style={{ margin: '10px', padding: '10px', fontSize }}
            avatar={<Add />}
            onClick={() => {
              const updatedTroubleProtocol = { ...troubleProtocol };
              updatedTroubleProtocol.isDeinstalledDevicesDialogOpen = true;

              const updatedTask = {
                ...task,
                troubleProtocol: updatedTroubleProtocol,
              };

              const updatedTasks = [...data.tasks];
              updatedTasks.splice(taskIndex, 1, updatedTask);

              dispatch(
                setData({
                  ...data,
                  tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
                })
              );
            }}
            clickable
            label="Добави деинсталирано оборудване"
          />
          <DeinstalledDevicesDialog />
          <DeinstalledDevicesList />
          {data?.sellMaterials?.length > 0 && (
            <div style={{ margin: '3px' }}>
              <MaterialsSell hasButtons={false} task={task} />
            </div>
          )}
          <FormControl style={{ marginTop: '10px' }} component="fieldset" variant="standard">
            <FormLabel
              style={{ marginTop: '10px', marginBottom: '10px', fontWeight: '900', color: 'black' }}
              component="legend"
            >
              Констатирани факти и обстоятелства:
            </FormLabel>
            <FormGroup>
              {circumstancesTexts.map(x => {
                return (
                  <FormControlLabel
                    key={`label${x.name}`}
                    control={
                      <Checkbox
                        id={x.name}
                        checked={circumstances.find(a => a.name === x.name).checked}
                        onChange={handleCircumstancesChange}
                        name={x.name}
                      />
                    }
                    label={x.label}
                  />
                );
              })}
            </FormGroup>
            <FormGroup>
              {circumstances.find(
                c => c.name === troubleProtocolActionsWithNote.circumstanceWithNote
              ) &&
              circumstances.find(
                c => c.name === troubleProtocolActionsWithNote.circumstanceWithNote
              ).checked ? (
                <TextField
                  label="Забележка"
                  value={troubleProtocol.circumstanceNote}
                  multiline
                  fullWidth
                  onChange={handleCircumstanceNote}
                  style={{ marginBottom: '15px' }}
                />
              ) : null}
            </FormGroup>
          </FormControl>
          <FormControl style={{ marginTop: '10px' }} component="fieldset" variant="standard">
            <FormLabel
              style={{ marginTop: '10px', marginBottom: '10px', fontWeight: '900', color: 'black' }}
              component="legend"
            >
              Предприети действия
            </FormLabel>
            <FormGroup>
              <FormGroup>
                {actionsTakenTexts.map(x => {
                  return (
                    <FormControlLabel
                      key={`label${x.name}`}
                      control={
                        <Checkbox
                          id={x.name}
                          checked={actionsTaken.find(a => a.name === x.name).checked}
                          onChange={handleActionTakenChange}
                          name={x.name}
                        />
                      }
                      label={x.label}
                    />
                  );
                })}
              </FormGroup>
              {actionsTaken.find(
                c => c.name === troubleProtocolActionsWithNote.actionTakenWithNote
              ) &&
              actionsTaken.find(c => c.name === troubleProtocolActionsWithNote.actionTakenWithNote)
                .checked ? (
                <TextField
                  label="Забележка"
                  value={troubleProtocol.actionTakenNote}
                  multiline
                  fullWidth
                  onChange={handleActionTakenNoteChange}
                  style={{ marginBottom: '15px' }}
                />
              ) : null}
            </FormGroup>
          </FormControl>
          <FormControl style={{ marginTop: '10px' }} component="fieldset" variant="standard">
            <FormLabel
              style={{ marginTop: '10px', marginBottom: '10px', fontWeight: '900', color: 'black' }}
              component="legend"
            >
              Други действия:
            </FormLabel>
            <FormGroup>
              {additionalActionsTexts.map(x => {
                return (
                  <FormControlLabel
                    key={`label${x.name}`}
                    control={
                      <Checkbox
                        id={x.name}
                        checked={additionalActions.find(c => c.name === x.name).checked}
                        onChange={handleAdditionalActionsChange}
                        name={x.name}
                      />
                    }
                    label={x.label}
                  />
                );
              })}
            </FormGroup>
          </FormControl>
          <FormControl style={{ marginTop: '10px' }} component="fieldset" variant="standard">
            <FormLabel
              style={{ marginTop: '10px', marginBottom: '10px', fontWeight: '900', color: 'black' }}
              component="legend"
            >
              Затруднението с ползваните услуги не е отстранено поради следните причини:
            </FormLabel>
            <FormGroup>
              {failedActionTexts.map(x => {
                return (
                  <FormControlLabel
                    key={`label${x.name}`}
                    control={
                      <Checkbox
                        id={x.name}
                        checked={failedActions.find(c => c.name === x.name).checked}
                        onChange={handleFailedActionsChange}
                        name={x.name}
                      />
                    }
                    label={x.label}
                  />
                );
              })}
            </FormGroup>
            <FormGroup>
              {failedActions.find(
                c => c.name === troubleProtocolActionsWithNote.failedActionWithNote
              ) &&
              failedActions.find(
                c => c.name === troubleProtocolActionsWithNote.failedActionWithNote
              ).checked ? (
                <TextField
                  label="Забележка"
                  value={troubleProtocol.failedActionNote}
                  multiline
                  fullWidth
                  onChange={handleFailedActionNoteChange}
                  style={{ marginBottom: '15px' }}
                />
              ) : null}
            </FormGroup>
          </FormControl>
        </>
      ) : null}
    </>
  );
};
